import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { IonicModule, NavController } from '@ionic/angular';
import { Store } from '@ngxs/store';
import { AppFeaturesLang, AppFeaturesState } from 'src/app/portal/app-feature.state';
import { LoadingState, SetLoading } from '../loading.state';
import { AppFeaturesService } from 'src/app/portal/app-features.service';
import { firstValueFrom } from 'rxjs';
import { LangTagPipe } from 'src/app/features/shared-components/lang-tag.pipe';
import { FirebaseService } from '../firebase.service';

@Component({
	selector: 'app-no-internet',
	templateUrl: './no-internet.component.html',
	styleUrls: ['./no-internet.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [IonicModule, CommonModule, LangTagPipe],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
	standalone: true,
})
export class NoInternetComponent {
	lang$ = this.store.select(AppFeaturesState.langData);
	loadingWithSpinner$ = this.store.select(LoadingState.loadingWithSpinner);

	constructor(
		private store: Store,
		private navController: NavController,
		private appFeaturesState: AppFeaturesState,
		private appFeaturesService: AppFeaturesService,
		private firebaseService: FirebaseService,
	) {}

	async refreshApp() {
		this.store.dispatch(new SetLoading(true, this, true, this.refreshApp));

		try {
			await this.checkNetwork();
		} finally {
			this.store.dispatch(new SetLoading(false, this, true, this.refreshApp));
		}
	}

	async checkNetwork() {
		if (await this.appFeaturesState.networkStatus) {
			await this.firebaseService.initializeFirebase();

			let requestLang = await this.appFeaturesService.getCurrentLang();
			const { lang, langData } = this.appFeaturesState;

			if (Object.keys(langData).length > 0 && requestLang === lang) {
				this.navController.back();
				return;
			}

			if (requestLang === null) requestLang = 'en';

			const loadLang$ = this.store.dispatch(new AppFeaturesLang(requestLang));

			await firstValueFrom(loadLang$);
			this.navController.back();
		}
	}
}
